import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  const pageBackground = theme.palette.grey[400];
  const cellBase = {
    height: "52px !important",
    padding: "0 12px !important",
    boxSizing: "border-box" as const,
    border: "none !important",
    borderBottom: `1px solid ${theme.palette.divider} !important`,
    fontFamily: "Noto Sans Hebrew !important",
    fontSize: "14px !important",
    lineHeight: "21px !important",
    textAlign: "right !important" as "right",
  };

  return {
    root: {
      width: "100%",
      backgroundColor: pageBackground,
      borderRadius: "6px",
      border: `1px solid ${theme.palette.divider}`,
      "& > .MuiPaper-root": {
        width: "100%",
        backgroundColor: "transparent",
      },
      "& .MuiTableContainer-root": {
        width: "100%",
        overflow: "visible !important",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
      "& .MuiTable-root": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        backgroundColor: `${pageBackground} !important`,
      },
      "& .MuiTableCell-root": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .MuiTableHead-root .MuiTableCell-head, & [class*='cellHead']": {
        ...cellBase,
        position: "sticky !important",
        top: "0 !important",
        zIndex: 5,
        fontWeight: "500 !important",
        backgroundColor: `${pageBackground} !important`,
        color: `${theme.palette.text.primary} !important`,
      },
      "& .MuiTableBody-root .MuiTableRow-root": {
        height: "52px",
        backgroundColor: `${theme.palette.background.paper} !important`,
        "&:hover, &:hover .MuiTableCell-root": {
          backgroundColor: `${theme.palette.background.tableRowHover} !important`,
        },
      },
      "& .MuiTableBody-root .MuiTableCell-root": {
        ...cellBase,
        fontWeight: "400 !important",
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: `${theme.palette.secondary.main} !important`,
      },
      "& .MuiTableHead-root .MuiTableCell-head:nth-child(1), & .MuiTableBody-root .MuiTableCell-root:nth-child(1)":
        {
          width: "auto !important",
          textAlign: "left !important" as "left",
        },
      "& .MuiTableHead-root .MuiTableCell-head:nth-child(2), & .MuiTableBody-root .MuiTableCell-root:nth-child(2)":
        {
          width: "180px !important",
          textAlign: "right !important" as "right",
        },
      "& .MuiTableHead-root .MuiTableCell-head:nth-child(3), & .MuiTableBody-root .MuiTableCell-root:nth-child(3)":
        {
          width: "48px !important",
        },
    },
    menuButton: {
      padding: "0 !important",
    },
    menuPaper: {
      width: "129px !important",
      minWidth: "129px !important",
      maxWidth: "129px !important",
      height: "112px !important",
      borderRadius: "4px !important",
      border: `1px solid ${theme.palette.divider}`,
      paddingTop: "4px !important",
      paddingBottom: "4px !important",
      boxSizing: "border-box",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08) !important",
      overflow: "hidden",
      "& .MuiList-root": {
        padding: "0 !important",
        height: "100%",
        boxSizing: "border-box",
      },
    },
    menuItem: {
      "&&": {
        display: "flex",
        flexDirection: "row",
        direction: "ltr",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px",
        width: "100%",
        minHeight: "52px",
        height: "52px",
        padding: "0 12px",
        fontFamily: "Noto Sans Hebrew",
        fontSize: "14px",
        lineHeight: "21px",
        color: theme.palette.text.primary,
      },
    },
    menuItemLabel: {
      flex: 1,
      textAlign: "right",
    },
    menuItemIcon: {
      display: "inline-flex",
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
    },
   
  };
});
